import clsx from 'clsx'
import React from 'react'

import styles from './PopupDescription.module.scss'

interface PopupDescriptionProps {
  className?: string
  descriptionTitle?: string
  description?: string
  cardTitle: string
  cardText: string
  left: string
  top: string
}
const PopupDescription = ({
  className,
  descriptionTitle,
  description,
  cardTitle,
  cardText,
  left,
  top,
}: PopupDescriptionProps) => (
  <div className={clsx(styles.popupDescription, className && styles[className])} style={{ left, top }}>
    {description?.length && (
      <React.Fragment>
        <div className={styles.circle} />
        <div className={styles.line} />
        <div className={styles.description}>
          <div className={styles.bold}>{descriptionTitle}</div>
          <div>{description}</div>
        </div>
      </React.Fragment>
    )}
    <div className={styles.card}>
      <div className={styles.bold}>{cardTitle}</div>
      <div>{cardText}</div>
    </div>
  </div>
)

export default PopupDescription
